<template>
  <el-dialog
    title="关联所属组织"
    class="orgUpdate"
    width="80%"
    :close-on-click-modal="false"
    :visible.sync="view.visible">
    <el-table :data="dataList" row-key="id" ref="table" size="small" 
      @selection-change="chooseInstance" @row-click="shopRowClick" 
      border style="width: 100%;" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column
              type="selection"
              header-align="center"
              align="center"
              width="50">
      </el-table-column>
      <el-table-column
              type="index"
              width="50"
              label="序号">
      </el-table-column>
      <el-table-column
              prop="orgCode"
              header-align="left"
              align="left"
              label="编码">
      </el-table-column>
      <el-table-column
              prop="orgName"
              header-align="left"
              align="left"
              label="名称">
      </el-table-column>
      <el-table-column 
              prop="tenantName" 
              header-align="left" 
              align="left" 
              min-width="100" 
              label="租户">
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="view.visible = false">取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">确定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {fetchOrgForTenant, assignOrgForPosition, fetchOrgForMainBody} from '@/controller/sys'
  export default {
    data () {
      return {
        dataList: [],
        dataListSelections: [],
        dataListLoading: false,
        multiSelection: [],
        view: {
          visible: false,
          conheight: {
            height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
            'overflow-y': 'auto'
          }
        },
        viewData: {
        },
        dataForm: {
          ids: [],
          orgId: 0
        }
      }
    },
    methods: {
      init (ids) {
        this.dataForm.ids = ids
        this.view.visible = true
        this.dataListLoading = true
        if(this.$store.state.user.userInfo.typeId === 2){
          fetchOrgForTenant(
          ).then(data => {
            this.dataList = data.body
            this.dataListLoading = false
            this.$nextTick(() => {
              this.multiSelection = ids
              this.initMultiSelection(this.dataList)
            })
          })
        }else {
          fetchOrgForMainBody(
                  {}, sessionStorage.getItem('mainBodyId')
          ).then(data => {
            this.dataList = data.body
            this.dataListLoading = false
            this.$nextTick(() => {
              this.multiSelection = ids
              this.initMultiSelection(this.dataList)
            })
          })
        }
      },
      // 表格选择事件
      chooseInstance(val) {
          if (val.length > 1) {
              this.$refs.table.clearSelection()
              this.$refs.table.toggleRowSelection(val.pop())
          }
      },
      // 选择表格行，即可选中
      shopRowClick(row) {
          this.$refs.table.toggleRowSelection(row)
      },
      // 表单提交
      dataFormSubmit () {
        if (this.$refs.table.selection.length == 1) {
            this.dataForm.orgId = this.$refs.table.selection[0].id
        } else {
            this.dataForm.orgId = 0
        }

        if (!this.dataForm.orgId) {
            this.$message({
                message: '请选择组织再提交！'
            })
            return;
        }
        assignOrgForPosition(
            {
                'positionIds': this.dataForm.ids,
                'orgId': this.dataForm.orgId
            }
        ).then(data => {
            if (data && data.code === '00') {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                        this.view.visible = false
                        this.$emit('refreshDataList')
                    }
                })
            }
        }).catch(error => {
            console.log(error)
        })
      }
    }
  }
</script>
<style lang="scss">
.orgUpdate thead .el-table-column--selection .cell{
    display: none;
}
</style>